import React from 'react'
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Paper } from '@mui/material'
import moment from 'moment/moment'

const DispatchMiddSection2 = ({
  tableData,
  loginData,
  reportType,
  showSummaryReport,
  detailedFilter,
  selFromBranch,
  selDestCity,
  selBranch,
  toDate,
  fromDate,
  selVehicle,
  selPaymentTpe,
}) => {
  const SecontInsideRowContent = ({ item, index,fontVal }) => {
    return (
      <>
        <TableRow>
          {Object.keys(item).length == 12 ? (
            <>
              <TableCell
                className="receivedTD"
                style={{
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
                  background: '#f1f9ff',
                  height:'36px'
                }}
                colSpan={18}
              >
                {item.SN}
              </TableCell>
            </>
          ) : Object.keys(item).length == 17 ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={11}
                style={{
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
                  height:'36px'
                }}
              >
                {item.OnlyLRNo}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.Quantity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.Freight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.HamaliCharges}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.CartageAmount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.Insurance}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.AllOther}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.NetAmount}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.SN}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.OnlyLRNo}&nbsp; <br />
                {item.VoucherNo} <br /> {item.ManualLR}&nbsp;
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.VehicleNoFilter}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.DispatchDateTime}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.BookCity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.ToCity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.DispatchedToCityFilter}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '150px',
                }}
              >
                <Tooltip title={item.DispatchedToBranchFilter} placement="top-start">
                  <span>{item.DispatchedToBranchFilter}</span>
                </Tooltip>
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '150px',
                }}
              >
                <Tooltip title={`${item.SenderName} ${item.SenderMobileNo} ${item.SenderGSTN} ${item.SenderEmailID}`} placement="top-start">
                      <span>{item.SenderName} <br /> {item.SenderMobileNo}<br /> {item.SenderGSTN} <br /> {item.SenderEmailID}</span>
                </Tooltip>             
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '150px',
                }}
              >
                <Tooltip title={`${item.RecName} ${item.RecMobileNo} ${item.ReceiverGSTN} ${item.ReceiverEmailID}`} placement="top-start">
                      <span>{item.RecName} <br /> {item.RecMobileNo}<br /> {item.ReceiverGSTN} <br /> {item.ReceiverEmailID}</span>
                </Tooltip> 
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '150px',
                }}
              >
                <Tooltip title={item.ItemDetails} placement="top-start">
                      <span>{item.ItemDetails}</span>
                </Tooltip>
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.Quantity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.Freight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.HamaliCharges}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.CartageAmount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.Insurance}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.AllOther}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  verticalAlign:'top',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.NetAmount}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }
  const SecontInsideRowContentForExcel = ({ item, index,fontVal }) => {
    return (
      <>
        <TableRow>
          {Object.keys(item).length == 12 ? (
            <>
              <TableCell
                className="receivedTD"
                style={{
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
                  background: '#f1f9ff',
                  height:'36px'
                }}
                colSpan={18}
              >
                {item.SN}
              </TableCell>
            </>
          ) : Object.keys(item).length == 17 ? (
            <>
              <TableCell
                className="reportTD"
                colSpan={11}
                style={{
                  background: '#EEE',
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  borderbottom: '1px solid rgba(0, 0, 0, 0.10)',
                }}
              >
                {item.OnlyLRNo}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.Quantity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.Freight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.HamaliCharges}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.CartageAmount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.Insurance}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.AllOther}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontSize: fontVal,
                  fontWeight: '700',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  background: '#EEE'
                }}
              >
                {item.NetAmount}
              </TableCell>
            </>
          ) : (
            <>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.SN}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {item.OnlyLRNo}&nbsp; <br />
                {item.VoucherNo} <br /> {item.ManualLR}&nbsp;
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.VehicleNoFilter}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'pre',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.DispatchDateTime}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.BookCity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.ToCity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.DispatchedToCityFilter}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  fontWeight: 'bold',
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '150px',
                  verticalAlign:'top'
                }}
              >
                <Tooltip title={item.DispatchedToBranchFilter} placement="top-start">
                  <span>{item.DispatchedToBranchFilter}</span>
                </Tooltip>
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '150px',
                }}
              >
                <Tooltip title={`${item.SenderName} ${item.SenderMobileNo} ${item.SenderGSTN} ${item.SenderEmailID}`} placement="top-start">
                      <span>{item.SenderName} <br /> {item.SenderMobileNo}<br /> {item.SenderGSTN} <br /> {item.SenderEmailID}</span>
                </Tooltip>             
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '150px',
                }}
              >
                <Tooltip title={`${item.RecName} ${item.RecMobileNo} ${item.ReceiverGSTN} ${item.ReceiverEmailID}`} placement="top-start">
                      <span>{item.RecName} <br /> {item.RecMobileNo}<br /> {item.ReceiverGSTN} <br /> {item.ReceiverEmailID}</span>
                </Tooltip> 
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '150px',
                  verticalAlign:'top'
                }}
              >
                <Tooltip title={item.ItemDetails} placement="top-start">
                      <span>{item.ItemDetails}</span>
                </Tooltip>
              </TableCell>

              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.Quantity}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.Freight}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.HamaliCharges}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.CartageAmount}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.Insurance}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.AllOther}
              </TableCell>
              <TableCell
                className="reportTD"
                colSpan={1}
                style={{
                  background: 'F5FAFE',
                  fontSize: fontVal,
                  fontWeight: '500',
                  textAlign: 'right',
                  whiteSpace: 'nowrap',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                  verticalAlign:'top'
                }}
              >
                {item.NetAmount}
              </TableCell>
            </>
          )}
        </TableRow>
      </>
    )
  }
  return (
    <>
      <Stack sx={{ marginLeft: 2, marginRight: 2, height: 480, paddingTop: '10px' }}  >
        <TableContainer className="scrollBlue" sx={{"&::-webkit-scrollbar": {width:'6px',height:'6px'},border:'1px solid #aeaeae','& .MuiTableCell-root': {
            fontSize: '14px !important'
        }}} component={Paper}>
          <Table  className="table1 table-Report" size="small" aria-label="a dense table">
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              <TableRow >
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '14px', fontWeight: '700', textAlign: 'left', color: '#444444',height:'36px',backgroundColor: '#bfe1ff' }}
                  colSpan={6}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '14px', fontWeight: '700', textAlign: 'left', color: '#444444',backgroundColor: '#bfe1ff' }}
                  colSpan={6}
                >
                  Destination City: {selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '14px', fontWeight: '700', textAlign: 'left', color: '#444444',backgroundColor: '#bfe1ff' }}
                  colSpan={6}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '700',
                    textAlign: 'right',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    
                  }}
                  colSpan={1}
                >
                  SN
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  LR No. <br /> ChallanNo. <br /> Manual LR No.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Vehicle <br /> No.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Dispatch <br /> Date & Time
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Source <br /> CIty
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Destination <br />
                  City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Dispatch <br /> To City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Dispatch <br /> To Branch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Sender <br /> Details
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Receiver <br />
                  Details
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Item <br /> Details
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Hamali
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Cartage
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Valuation
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Other <br /> Charges
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '12px',
                    fontWeight: '500',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Net <br /> Amount
                </TableCell>
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={18}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '12px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{
                  textAlign: 'center',
                  fontSize: '12px',
                  fontWeight: '500',
                  marginLeft: '5px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {tableData?.map((item, index) => (
                  <SecontInsideRowContent item={item} index={index} key={index} fontVal={'12px'}/>
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
          <Table style={{display:'none'}} id="tables" className="table1 table-Report" size="small" aria-label="a dense table">
            <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={9}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Report -</h3>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={9}
                >
                  <h3 style={{ paddingLeft: '17px' }}>Company Name :{loginData.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={18}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  From Dispatch Date
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  To Dispatch Date
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  dispatch By Branch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Destination City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  DestinationBranch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Vehicle Number
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={1}
                >
                  Payment Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Report Type
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Report View
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#bfe1ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                  }}
                  colSpan={2}
                >
                  Report Option
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selFromBranch?.name || loginData?.strBranchName}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selDestCity?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{selBranch?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{selVehicle?.name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={1}
                >
                  <span>{selPaymentTpe?.name || 'All'}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{reportType?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{showSummaryReport?.Name}</span>
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                  colSpan={2}
                >
                  <span>{detailedFilter?.Name} </span>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={18}></TableCell>
              </TableRow>
            </TableHead>
            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
              <TableRow >
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '20px', fontWeight: '700', textAlign: 'left', color: '#444444',height:'36px',backgroundColor: '#bfe1ff' }}
                  colSpan={6}
                >
                  Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '20px', fontWeight: '700', textAlign: 'left', color: '#444444',backgroundColor: '#bfe1ff' }}
                  colSpan={6}
                >
                  Destination City: {selDestCity?.name}
                </TableCell>
                <TableCell
                  className="reportTD"
                  style={{ fontSize: '20px', fontWeight: '700', textAlign: 'left', color: '#444444',backgroundColor: '#bfe1ff' }}
                  colSpan={6}
                >
                  Destination Branch: {selBranch?.name}
                </TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    verticalAlign:'top'
                    
                  }}
                  colSpan={1}
                >
                  SN
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  LR No. <br /> ChallanNo. <br /> Manual LR No.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Vehicle <br /> No.
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Dispatch <br /> Date & Time
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Source <br /> CIty
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Destination <br />
                  City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Dispatch <br /> To City
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Dispatch <br /> To Branch
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Sender <br /> Details
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Receiver <br />
                  Details
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Item <br /> Details
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    verticalAlign:'top'
                  }}
                  colSpan={1}
                >
                  Units
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    verticalAlign:'top'
                  }}
                  colSpan={1}
                >
                  Freight
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    verticalAlign:'top'
                  }}
                  colSpan={1}
                >
                  Hamali
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    verticalAlign:'top'
                  }}
                  colSpan={1}
                >
                  Cartage
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    verticalAlign:'top'
                  }}
                  colSpan={1}
                >
                  Valuation
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Other <br /> Charges
                </TableCell>
                <TableCell
                  className="ReportItemHead"
                  style={{
                    backgroundColor: '#e5f3ff',
                    color: '#454646',
                    fontSize: '20px',
                    fontWeight: '600',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                  }}
                  colSpan={1}
                >
                  Net <br /> Amount
                </TableCell>
              </TableRow>
            </TableHead>
            {tableData?.length < 1 ? (
              <>
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={18}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '20px',
                        }}
                      >
                        <span>No results found. Please refine your search parameters and search again.</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </>
            ) : tableData?.length >= 1 ? (
              <TableBody
                className="filter-data-row"
                style={{
                  textAlign: 'center',
                  fontSize: '20px',
                  fontWeight: '500',
                  marginLeft: '5px',
                  lineheight: '16px',
                  letterspacing: '0.24px',
                }}
              >
                {tableData?.map((item, index) => (
                  <SecontInsideRowContentForExcel item={item} index={index} key={index} fontVal={'20px'}/>
                ))}
              </TableBody>
            ) : (
              ''
            )}
          </Table>
        </TableContainer>
      </Stack>
    </>
  )
}

export default DispatchMiddSection2
